module.exports = __webpack_public_path__ + "static/media/HHTripsList.a4ed6ebd.png";